import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Card,
  Button,
  Image,
  Form,
  FormControl,
} from "react-bootstrap";
import CompanyDetails from "../Components/CompanyDetails";
import { handleGetCompanies } from "../API/CompanyApi";
import { toast } from "react-toastify";
import avatar from "./Avatar.png";
import { handlSessionOut } from "../API/AuthService";
const Home = () => {
  const [companyList, setCompanyList] = useState([]);
  const [companyListAux, setCompanyListAux] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCompany, setSelectedCompany] = useState('')

  const handleGetCompaniesList = async () => {
    try {
      const resData = await handleGetCompanies();
      if (resData?.data) {
        setCompanyList(resData.data);
        setCompanyListAux(resData.data);
      }
    } catch (err) {
      if (err.response?.data?.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  useEffect(() => {
    handleGetCompaniesList();
    //eslint-disable-next-line
  }, []);

  const handleSearch = () => {
    const filteredResults = companyListAux.filter((item) => {
      return item.name.toLowerCase().includes(searchQuery.toLowerCase());
    });
    setCompanyList(filteredResults);
  };

  const handleLogout = async() => {
   try{
     await handlSessionOut()
     toast.info('Logged out')
     localStorage.removeItem('Aprofile')
     window.location.reload()
   }catch(err){
    toast.info('Logged out')
    localStorage.removeItem('Aprofile')
    window.location.reload()
   }
  }   
  return (
    <Container fluid>
      <Card className="my-2">
        <Card.Body className="d-flex">
          <Button onClick={() => handleLogout()} className="ms-auto">Log out</Button>
        </Card.Body>
      </Card>
      <Row className="homecontainer m-2 scroller">
        {/* Left Pane */}
        <Col
          sm={12}
          lg={4}
          md={4}
          style={{ borderRight: "1px solid #ddd" }}
          className="my-2"
        >
          {/* Content for the left pane */}
          <Card>
            <Card.Header>
              <Form inline>
                <FormControl
                  type="text"
                  placeholder="Search"
                  className="mr-sm-2"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <Button
                  className="my-3 mx-2"
                  variant="outline-success"
                  onClick={handleSearch}
                >
                  Search
                </Button>
                <Button
                  className="my-3 mx-2"
                  variant="outline-danger"
                  onClick={() => {
                    setSearchQuery('')
                    setCompanyList(companyListAux)}}
                >
                  clear
                </Button>
              </Form>
            </Card.Header>
            <Card.Header>Companies</Card.Header>
            <ListGroup className="list-card scroller">
              {companyList.length > 0 &&
                companyList.map((cmp, i) => (
                  <ListGroupItem onClick={() => setSelectedCompany(cmp)}>
                    <Row key={i+1000}>
                      <Col xs={2}>
                        <Image
                          src={cmp?.comLogo?.length > 3 ? cmp.comLogo : avatar}
                          roundedCircle
                          fluid
                        />
                      </Col>
                      <Col xs={10}>
                        <h5>{cmp.name}</h5>
                        <p>{cmp.email}</p>
                      </Col>
                    </Row>
                  </ListGroupItem>
                ))}
            </ListGroup>
          </Card>

          {/* Add your left pane content here */}
        </Col>

        {/* Right Pane */}
        <Col sm={12} lg={8} md={8} className="right-column scroller my-2">
          {/* Content for the right pane */}
          <CompanyDetails company={selectedCompany} getList={handleGetCompaniesList} />
          {/* Add your right pane content here */}
        </Col>
      </Row>
    </Container>
  );
};

export default Home;
